import axiosClient from "../api/axiosClient";

/**
 * Sub-Accounts (Promoter Panel spec ch.11.2-11.4) — internal Business access
 * within a Business Account, own login, permissions assigned by the owner
 * across 9 blocks. New backend controller: WebAPI's SubAccountController.
 */

// --- Owner-side management ---
export const inviteSubAccount = (payload) => axiosClient.post("/SubAccount/Invite", payload);
export const getMySubAccounts = () => axiosClient.get("/SubAccount/MySubAccounts");
export const updateSubAccountPermissions = (id, permissions) =>
  axiosClient.put("/SubAccount/Permissions", permissions, { params: { id } });
export const blockSubAccount = (id) => axiosClient.post("/SubAccount/Block", null, { params: { id } });
export const unblockSubAccount = (id) => axiosClient.post("/SubAccount/Unblock", null, { params: { id } });
export const removeSubAccount = (id) => axiosClient.delete("/SubAccount/Delete", { params: { id } });
export const resendSubAccountInvite = (id) => axiosClient.post("/SubAccount/ResendInvite", null, { params: { id } });

/** Owner-only — what every Sub-Account has done, so the Business Account can review it (spec ch.11.2/11.4/11.12). */
export const getSubAccountActivityLog = (pageNumber = 1, pageSize = 20) =>
  axiosClient.get("/SubAccount/ActivityLog", { params: { pageNumber, pageSize } });

// --- My context (any logged-in user, called once after login) ---
export const getMySubAccountContext = () => axiosClient.get("/SubAccount/MyContext");

// --- Public invite acceptance (no auth token yet) ---
export const validateInviteToken = (token) => axiosClient.get("/SubAccount/ValidateInvite", { params: { token } });
export const acceptInvite = (payload) => axiosClient.post("/SubAccount/AcceptInvite", payload);
